import { render, staticRenderFns } from "./RelocationTemplate.vue?vue&type=template&id=2a5cda05&scoped=true"
import script from "./RelocationTemplate.vue?vue&type=script&lang=js"
export * from "./RelocationTemplate.vue?vue&type=script&lang=js"
import style0 from "./RelocationTemplate.vue?vue&type=style&index=0&id=2a5cda05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5cda05",
  null
  
)

export default component.exports